import React from "react";
import { useTranslation } from "react-i18next";
import { StatusBadge, StatusDot } from "../../styledComponents/common";

const StatusWithDot = ({ status }) => {
  const { t } = useTranslation();

  if (!status) {
    return (
      <StatusBadge status={null}>
        <StatusDot status={null} />
        -
      </StatusBadge>
    );
  }

  let normalizedStatus = status.toLowerCase();

  // Map status to translation key
  const getStatusText = () => {
    switch (normalizedStatus) {
      case "unscheduled":
        return t("unscheduled");
      case "ready to dispatch":
        return t("ready_to_dispatch");
      case "scheduled":
        return t("scheduled");
      case "completed":
        return t("completed");
      case "partially complete":
      case "partially_completed":
        return t("partially_completed");
      case "totally missed":
      case "totally_missed":
        return t("totally_missed");
      case "late":
        return t("late");
      case "in progress":
      case "in_progress":
        return t("in_progress");
      case "missed":
        return t("missed");
      case "complete":
        return t("complete");
      case "open":
        return t("open");
      case "pending":
        return t("pending");
      case "approved":
        return t("approved");
      case "rejected":
        return t("rejected");
      case "done":
        return t("done");
      case "not done":
      case "not_done":
        return t("not_done");
      case "submitted":
        return t("submitted");
      case "paid":
        return t("paid");
      case "unpaid":
        return t("unpaid");
      case "overdue":
        return t("overdue");
      case "partial":
      case "partially paid":
      case "partially_paid":
        return t("partially_paid");
      case "sent":
        return t("sent");
      case "draft":
        return t("draft");
      default:
        return "-";
    }
  };

  return (
    <StatusBadge status={status.toLowerCase()}>
      <StatusDot status={status.toLowerCase()} />
      {getStatusText()}
    </StatusBadge>
  );
};

export default StatusWithDot;

